import { UserContext } from '@/contexts/UserContext';

export function numberZeroOrBlank(num: number) {
  if (numberIsBlank(num) || num === 0) {
    return true;
  }
  return false;
}

export function numberIsBlank(num: number) {
  if (num === undefined || num === null) {
    return true;
  }
  return false;
}

export function isNotTokenUser(ctx: UserContext) {
  return !ctx?.isToken();
}
